import React from 'react';
import PropTypes from 'prop-types';

import { Text, Avatar, IOSSwitch, StyledCard, StyledCardContent } from '../../index';

export const ModeratorCard = ({ data, switchState, onSwitchChange, disabled, showSwitch }) => {
    return (
        <StyledCard style={{ padding: '15px 20px', height: 'max-content' }}>
            <StyledCardContent>
                <div>
                    <Text $fontSize="18px" $bold style={{ marginBottom: '10px' }}>
                        Moderator
                    </Text>
                    <StyledCard padding="5px" margin="0 0 10px">
                        <StyledCardContent style={{ display: 'flex', columnGap: '15px' }}>
                            <Avatar
                                alt={data.staff?.user?.fullname}
                                src={data.staff?.user ? data.staff.user?.avatar?.url : null}
                                $avatarSize="48px"
                                $borderRadius="16px"
                            />

                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <Text
                                    style={{
                                        fontSize: '14px',
                                    }}
                                    $ellipsis
                                    $lineHeight="20px"
                                    $bold
                                >
                                    {data.staff?.user?.fullname}
                                </Text>
                                {/*   <Text $fontSize="12px" $color="gray3">
                                 {data.staff?.user?.ready ? 'Ready' : 'Not Ready'} 
                                    Not Ready
                                </Text> */}
                            </div>
                        </StyledCardContent>
                    </StyledCard>
                </div>
                {showSwitch && (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            rowGap: '15px',
                            marginTop: '30px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Text $color="gray2">Speak To Text</Text>
                            <div
                                style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}
                            >
                                <IOSSwitch
                                    checked={switchState.speakToText}
                                    onChange={onSwitchChange}
                                    name="speakToText"
                                    disabled={disabled}
                                />
                                <Text style={{ width: '24px' }}>
                                    {switchState.speakToText ? 'On' : 'Off'}
                                </Text>
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Text $color="gray2">Sound Record</Text>
                            <div
                                style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}
                            >
                                <IOSSwitch
                                    checked={switchState.soundRecord}
                                    onChange={onSwitchChange}
                                    name="soundRecord"
                                    disabled={disabled}
                                />
                                <Text style={{ width: '24px' }}>
                                    {switchState.soundRecord ? 'On' : 'Off'}
                                </Text>
                            </div>
                        </div>
                    </div>
                )}
            </StyledCardContent>
        </StyledCard>
    );
};

ModeratorCard.propTypes = {
    data: PropTypes.object,
    switchState: PropTypes.object,
    onSwitchChange: PropTypes.func,
    currentSession: PropTypes.object,
    disabled: PropTypes.bool,
    showSwitch: PropTypes.bool,
};
